import React from 'react'

const FollowSection = () => {
    return (
        <div className='sm:py-[96px] py-[48px] px-[7.7vw] max-lg:flex-col max-w-[1980px] flex items-center gap-[64px]'>
            <div className="w-full flex items-start justify-center  md:h-[500px] max-md:max-h-[450px] max-md:max-w-[100%] overflow-hidden">
                <img src="/images/followImage.png" className='max-w-[650px]' alt="" />
            </div>
            <div className="flex flex-col gap-[24px] w-full max-sm:items-center">
                <h1 className='text-[#101828] font-[600] md:text-[48px] max-md:text-[36px] max-sm:text-center max-sm:text-[32px] max-w-[520px]'>
                    Follow Us for Fitness Tips and More
                </h1>
                <p className='text-[20px] text-[#475467] max-w-[520px] max-sm:text-center'>
                    Connect with Us on Social Media
                </p>
                <div className="flex items-center sm:gap-[60px] gap-[24px]">
                    <img src="/images/social-icon.png" alt=""  className='max-sm:w-[40px] cursor-pointer transition-all hover:opacity-65'/>
                    <img src="/images/social-icon-1.png" alt=""  className='max-sm:w-[40px] cursor-pointer transition-all hover:opacity-65'/>
                    <img src="/images/social-icon-2.png" alt=""  className='max-sm:w-[40px] cursor-pointer transition-all hover:opacity-65'/>
                </div>
            </div>
        </div>
    )
}

export default FollowSection;